module.exports = __webpack_public_path__ + "img/15.eed537d8.png";